<template>
  <section class="pcMunberTree">
    <el-tree
      v-if="showDeptTree"
      :props="treeProps"
      :load="loadNode"
      :expand-on-click-node="false"
      :default-expanded-keys="defaultExpandedKeys"
      node-key="id"
      ref="pcMunberTree"
      lazy
      empty-text="暂无数据"
    >
      <span
        class="custom-tree-node"
        slot-scope="{ node, data }"
        @click="
          () => {
            treeClick(node, data);
          }
        "
      >
        <span>
          <i class="el-icon-folder"></i>
          <span>{{ node.label }}</span>
        </span>
        <span v-if="editOrgPrivilege" class="custom-tree-node-action">
          <el-button
            type="text"
            size="mini"
            @click.stop="() => deptAddChild(node, data)"
          >
            <i class="el-icon-plus"></i>
          </el-button>
          <el-button
            v-if="node.level != 1"
            type="text"
            size="mini"
            @click.stop="() => deptEdit(node, data)"
          >
            <i class="el-icon-edit"></i>
          </el-button>
          <el-button
            v-if="node.level != 1 && data.has_child"
            type="text"
            size="mini"
            @click.stop="() => deptDel(node, data)"
          >
            <i class="el-icon-delete"></i>
          </el-button>
        </span>
      </span>
    </el-tree>
    <el-dialog
      class="addOrEditNode"
      :title="addOrEditNodeObj.id ? '修改部门' : '新增部门'"
      :visible.sync="addOrEditNodeObj.dialogVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <div>
        <el-row type="flex" align="middle" :gutter="10">
          <el-col :span="6"><span>上级部门：</span></el-col>
          <el-col :span="18">
            <span>{{ addOrEditNodeObj.prarentName }}</span>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" :gutter="10">
          <el-col :span="6"><span>部门名称：</span></el-col>
          <el-col :span="18">
            <el-input
              v-model="addOrEditNodeObj.name"
              placeholder="请输入部门名称"
            ></el-input>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle" :gutter="10">
          <el-col :span="6"><span>部门排序：</span></el-col>
          <el-col :span="18">
            <el-input
              v-model="addOrEditNodeObj.order"
              placeholder="请输入部门排序"
            ></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addOrEditNodeObj.dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="comfireAddDept">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="delDeptNode"
      title="确认删除"
      :visible.sync="delDeptNodeObj.dialogVisible"
      :close-on-click-modal="false"
      width="400px"
    >
      <div>
        <span
          >确认删除
          <span class="red">{{
            delDeptNodeObj.data && delDeptNodeObj.data.name
          }}</span>
          部门吗？删除后数据无法恢复
        </span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="delDeptNodeObj.dialogVisible = false"
          >取 消</el-button
        >
        <el-button size="small" type="danger" @click="comfiredelDept"
          >删 除</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import mixinOrgUrl from "@/components/qyDept/mixinOrgUrl.js";
export default {
  props: {
    // 是否拥有编辑权限
    editOrgPrivilege: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  data() {
    return {
      orgUrl: {},
      treeProps: {
        label: "name",
        children: "child",
        isLeaf: "has_child"
      },
      topDeptData: {},
      showDeptTree: false,
      defaultExpandedKeys: [],
      dialogVisible: false,
      addOrEditNodeObj: {
        dialogVisible: false,
        node: {},
        prarentName: "",
        order: "",
        name: "",
        p_id: "",
        id: ""
      },
      delDeptNodeObj: {
        dialogVisible: false,
        data: {},
        node: {}
      }
    };
  },
  watch: {},
  components: {},
  async mounted() {},
  mixins: [mixinOrgUrl],
  methods: {
    getLvDeptId() {
      return new Promise(resolve => {
        this.$common
          .http({
            url: this.orgUrl.getDeptTop,
            data: {}
          })
          .then(res => {
            const topDeptData = res.data.data;
            topDeptData.forEach(item => {
              item.has_child = Number(item.has_child) === 1 ? false : true;
              item.child.forEach(item1 => {
                item1.has_child = Number(item1.has_child) === 1 ? false : true;
              });
            });
            // this.$emit("setData", topDeptData);
            resolve(topDeptData);
          });
      });
    },
    async loadNode(node, resolve) {
      if (node.level === 0) {
        return resolve(this.topDeptData);
      }
      if (node.level === 1) {
        const id = node.data.id;
        let resData = [];
        this.topDeptData.forEach(item => {
          if (id == item.id) {
            resData = item.child;
          }
        });
        return resolve(resData);
      }
      if (node.level > 1) {
        const upLoadData = await this.listSubDepartments(node.data.id);
        return resolve(upLoadData);
      }
    },
    treeClick(node, data) {
      console.log(node, data);
      data.getTableUrl = this.orgUrl.getUserByDeptId;
      this.$emit("treeClick", data);
    },
    deptDel(node, data) {
      if (!data.has_child) {
        this.$common.pcToastFail("当前部门有子部门，请先删除子部门");
        return;
      }
      this.delDeptNodeObj.dialogVisible = true;
      this.delDeptNodeObj.node = node;
      this.delDeptNodeObj.data = data;
    },
    comfiredelDept() {
      console.log(this.delDeptNodeObj);
      this.$common
        .http({
          url: "/api/contact/delete_dept",
          data: {
            id: this.delDeptNodeObj.data.id
          }
        })
        .then(async () => {
          this.$common.pcToastSuccess("删除部门成功");
          let key = this.delDeptNodeObj.node.parent.data.id;
          let level = this.delDeptNodeObj.node.level;
          const upLoadData = await this.listSubDepartments(key);
          if (upLoadData.length == 0) {
            key = this.delDeptNodeObj.node.parent.parent.data.id;
            if (level == 2) {
              const lv1Data = await this.getLvDeptId();
              this.$refs.pcMunberTree.updateKeyChildren(key, lv1Data.child);
            } else {
              const upLoadData = await this.listSubDepartments(key);
              this.$refs.pcMunberTree.updateKeyChildren(key, upLoadData);
            }
          } else {
            this.$refs.pcMunberTree.updateKeyChildren(key, upLoadData);
          }
          this.delDeptNodeObj.dialogVisible = false;
        });
    },
    deptEdit(node, data) {
      this.addOrEditNodeObj.p_id = node.parent.data.id;
      this.addOrEditNodeObj.prarentName = node.parent.data.name;
      this.addOrEditNodeObj.name = data.name;
      this.addOrEditNodeObj.order = data.order;
      this.addOrEditNodeObj.id = data.id;
      this.addOrEditNodeObj.node = node;
      this.addOrEditNodeObj.data = data;
      this.addOrEditNodeObj.dialogVisible = true;
    },
    deptAddChild(node, data) {
      this.addOrEditNodeObj.p_id = data.id;
      this.addOrEditNodeObj.prarentName = data.name;
      this.addOrEditNodeObj.node = node;
      this.addOrEditNodeObj.name = "";
      this.addOrEditNodeObj.order = "";
      this.addOrEditNodeObj.dialogVisible = true;
    },
    comfireAddDept() {
      this.addOrEditNodeObj.dialogVisible = false;
      let data = {
        p_id: this.addOrEditNodeObj.p_id,
        name: this.addOrEditNodeObj.name,
        order: this.addOrEditNodeObj.order
      };
      let url = "/api/contact/create_dept";
      if (this.addOrEditNodeObj.id) {
        data.id = this.addOrEditNodeObj.id;
        url = "/api/contact/update_dept";
      }
      this.$common
        .http({
          url: url,
          data: data
        })
        .then(async () => {
          if (this.addOrEditNodeObj.id) {
            this.$common.pcToastSuccess("修改部门成功");
          } else {
            this.$common.pcToastSuccess("添加部门成功");
          }
          // 局部刷新数据
          let level = this.addOrEditNodeObj.node.level;
          let key = this.addOrEditNodeObj.node.data.id;
          if (this.addOrEditNodeObj.id) {
            level = this.addOrEditNodeObj.node.level;
            key = this.addOrEditNodeObj.node.parent.data.id;
            if (level == 2) {
              const lv1Data = await this.getLvDeptId();
              this.$refs.pcMunberTree.updateKeyChildren(key, lv1Data.child);
            } else {
              const upLoadData = await this.listSubDepartments(key);
              this.$refs.pcMunberTree.updateKeyChildren(key, upLoadData);
            }
          } else {
            if (level == 1) {
              const lv1Data = await this.getLvDeptId();
              this.$refs.pcMunberTree.updateKeyChildren(key, lv1Data.child);
            } else {
              const upLoadData = await this.listSubDepartments(key);
              this.$refs.pcMunberTree.updateKeyChildren(key, upLoadData);
            }
          }
        });
    },
    listSubDepartments(id) {
      // this.defaultExpandedKeys.push(id);
      return new Promise(resolve => {
        this.$common
          .http({
            url: this.orgUrl.getDept,
            data: {
              department_id: id
            }
          })
          .then(res => {
            let data = res.data.data || [];
            data.forEach(item => {
              item.has_child = Number(item.has_child) === 1 ? false : true;
            });
            resolve(data);
          });
      });
    }
  },
  async created() {
    this.orgUrl = await this.mixinOrgUrlSet();
    this.topDeptData = await this.getLvDeptId();
    if (this.topDeptData.length == 0) {
      return;
    }
    this.defaultExpandedKeys = [this.topDeptData[0].id];
    this.showDeptTree = true;
    // 加载列表数据
    // // this.fetchTableList();
    this.$emit("treeClick", {
      id: this.topDeptData[0].id,
      name: this.topDeptData[0].name,
      getTableUrl: this.orgUrl.getUserByDeptId
    });
  }
};
</script>
<style lang="less" scoped>
.pcMunberTree {
  width: 100%;
  overflow: auto;
  height: calc(100% - 55px);
  margin-top: 10px;
  .custom-tree-node {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .custom-tree-node-action {
      margin-right: 5px;
      display: none;
    }
    &:hover .custom-tree-node-action {
      display: inline-block !important;
    }
  }
}
.addOrEditNode {
  .el-row {
    padding-bottom: 10px;
    .el-col-6 {
      text-align: right;
    }
  }
}
.red {
  color: red;
}
</style>

<style lang="less">
.pcMunberTree {
  .el-tree-node__content {
    height: 32px;
    .el-icon-folder {
      color: cornflowerblue;
      margin-right: 2px;
    }
  }
}
.addOrEditNode {
  .el-dialog__body {
    padding: 10px 20px;
  }
}
.delDeptNode {
  .el-dialog__body {
    padding: 0 20px;
  }
}
</style>
